import { apiService } from '@/services/APIService';

export default {

  getPages(event_id, params) {
    return apiService.get(`/public/event-pages/events/${event_id}/constructor`, params);
  },
  savePages(event_id, params) {
    return apiService.post(`/event-pages/events/${event_id}/constructor`, params);
  },
};
